import { useState as I, useRef as b, useLayoutEffect as v, useMemo as h } from "react";
import { DEFAULT_ASPECT_RATIO as y } from "./constants.mjs";
import { getCurrentHeight as C, toFixed as m, getTargetAspectSumForRow as w } from "./utils.mjs";
function T({
  items: u,
  responsiveHeights: g,
  lastRowStretchThreshold: p,
  rowGapPx: d = 8,
  columnGapPx: o = 8
}) {
  const [r, S] = I(1200), i = b(null);
  v(() => {
    if (!i.current) return;
    const e = new ResizeObserver(([t]) => {
      S(t.contentRect.width);
    });
    return e.observe(i.current), () => e.disconnect();
  }, []);
  const n = C(g, r), { rows: a, lastRowIndex: c } = h(() => {
    if (!u.length) return { rows: [], lastRowIndex: -1 };
    const e = [];
    let t = [], s = 0;
    for (const f of u) {
      const l = m(f.aspectRatio || y), R = s + l, L = w(
        t.length + 1,
        n,
        o,
        r
      );
      R >= L && t.length > 0 ? (e.push({ items: t, aspectSum: s, isLastRow: !1 }), t = [f], s = l) : (t.push(f), s = R);
    }
    return t.length > 0 && e.push({ items: t, aspectSum: s, isLastRow: !0 }), { rows: e, lastRowIndex: e.length - 1 };
  }, [u, n, r, d, o]), A = h(() => {
    if (c < 0) return !1;
    const e = a[c], t = w(
      e.items.length,
      n,
      o,
      r
    ), s = m(t * p);
    return e.aspectSum >= s;
  }, [c, a, n, p, r, o]);
  return { rows: a, lastRowIndex: c, shouldLastRowStretch: A, containerRef: i };
}
export {
  T as useJustifiedGalleryLayout
};
